export default class UploadHandler {
	constructor(app, state) {
		this.initUploader(app);
		this.initEvents(app, state);
	}

	initEvents(app, state) {
		app.attachEvent("app:action", (name, info) => {
			if (name == "upload" || name == "uploaddir") {
				if (!info) info = state.path || "/";
				this.openDialog(name, info);
			}
		});
	}

	initUploader(app) {
		this.uploader = this.createUploader(app);
		this.dirUploader = this.createUploader(app, true);
	}

	createUploader(app, directory) {
		const uploader = webix.ui({
			view: "uploader",
			directory,
			apiOnly: true,
			upload: app.getService("backend").upload(),
			on: {
				onAfterFileAdd: function(item) {
					item.urlData = this.config.tempUrlData;
				},
				onUploadComplete: function() {
					app.getService("progress").end();
					app.callEvent("reload:fs:stats", []);

					if (directory) {
						const path = this.config.tempUrlData.id;
						const local = app.getService("local");
						local.refresh(path);
						local.folders(true);
					}
				},
			},
		});

		if (!directory)
			uploader.attachEvent("onFileUpload", (file, res) => {
				app.getService("local").addFile(file.urlData.id, res);
			});

		uploader.$updateProgress = (_, percent) => {
			const progress = percent / 100;
			if (progress) app.getService("progress").start(progress);
		};

		return uploader;
	}

	openDialog(type, id) {
		const uploader = type == "upload" ? this.uploader : this.dirUploader;
		uploader.config.tempUrlData = { id };
		uploader.fileDialog();
	}

	// required for DND of files and folders
	getUploader() {
		return this.dirUploader;
	}
}
